"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const STEP1 = "STEP1"; // Formulaire saisi adresse email
const STEP2 = "STEP2"; // Check existence de l'email
const STEP3 = "STEP3"; // Formulaire création compte : client non présent dans SI.
const STEP3dot1 = "STEP3.1"; // Formulaire création compte : client présent sans compte web qui refuse son activation
class ModalIdentification {
    constructor(selector, options) {
        this.DOM = {
            $wrapper: null
        };
        this.options = {
            nextClassname: "-next",
            buttonSelector: "#js-next-step",
            closeSelector: "#js-close-modal",
        };
        if (selector) {
            this.DOM.$wrapper = $(selector);
            if (options) {
                this.options = Object.assign(Object.assign({}, this.options), options);
            }
            //IMPORTANT : RAPPELER les fonctions avec un bind(this) si vous voulez avoir accès au "this" en dehors de la classe
            this.setHtml = this.setHtml.bind(this);
        }
    }
    addEvents() {
        // Click pour passer à l'étape d'après
        this.DOM.$wrapper.find(this.options.buttonSelector).on("click", (e) => {
            e.preventDefault();
            this.DOM.$wrapper.addClass(this.options.nextClassname);
        });
        // Click pour fermer la modal
        this.DOM.$wrapper.find(this.options.closeSelector).on("click", (e) => {
            e.preventDefault();
            this.close();
        });
        this.DOM.$wrapper.on('closed.fndtn.reveal', (e) => {
            // Evite un bug de foundation qui fait 2 events "closed" en même temps
            if (e.namespace !== 'fndtn.reveal') {
                return;
            }
            this.DOM.$wrapper.removeClass(this.options.nextClassname);
        });
    }
    close() {
        this.DOM.$wrapper.foundation('reveal', 'close');
        this.DOM.$wrapper.attr("data-options", "");
        this.DOM.$wrapper.on('closed.fndtn.reveal', (e) => {
            // Evite un bug de foundation qui fait 2 events "closed" en même temps
            if (e.namespace !== 'fndtn.reveal') {
                return;
            }
            this.DOM.$wrapper.removeClass(this.options.nextClassname);
            if (this.options.onClose) {
                this.options.onClose();
            }
        });
    }
    setHtml(html) {
        // Mets l'html dans la modal
        this.DOM.$wrapper.html(html);
        // Ouvre la modal
        if (this.options.foundationOptions) {
            this.DOM.$wrapper.attr("data-options", this.options.foundationOptions);
        }
        this.DOM.$wrapper.foundation('reveal', 'open');
        this.DOM.$wrapper.on('opened.fndtn.reveal', (e) => {
            // Evite un bug de foundation qui fait 2 events "opened" en même temps
            if (e.namespace !== 'fndtn.reveal') {
                return;
            }
            this.addEvents();
        });
    }
}
class Identification {
    constructor(selector, options) {
        this.selector = "";
        this.DOM = {
            $wrapper: null,
            $content: null,
            $back: null,
            $messageContainer: null,
            $messageInitClass: null,
            $title: null,
        };
        this.modal = new ModalIdentification("");
        this.options = {
            contentSelector: "#js-identification__account",
            backSelector: "#js-back",
        };
        this.toggleButton = new ToggleButton("", { on: () => { }, off: () => { } });
        this.currentStep = STEP1;
        this.returnUrl = "";
        if (selector) {
            if (options) {
                this.options = Object.assign(Object.assign({}, this.options), options);
            }
            this.selector = ".identification__account";
            this.DOM.$wrapper = $(selector);
            this.DOM.$content = $(selector).find(this.options.contentSelector);
            this.DOM.$back = $(selector).find(this.options.backSelector);
            this.DOM.$messageContainer = $(selector + "__message");
            this.DOM.$messageInitClass = $(selector + "__message").attr("class");
            this.DOM.$title = $(selector + "__title");
            this.returnUrl = this.DOM.$wrapper.data("return");
            //Initialise la modal avec la class ModalIdentification plus haut + options foundation et callback onclose
            this.modal = new ModalIdentification("#ajax-modal-small", {
                foundationOptions: "close_on_background_click: false; close_on_esc: false;"
            });
            //IMPORTANT : RAPPELER les fonctions avec un bind(this) si vous voulez avoir accès au "this" en dehors de la classe
            this.onSuccessGoToCreateAccountWithID = this.onSuccessGoToCreateAccountWithID.bind(this);
            this.onSuccessCheckEmailAddress = this.onSuccessCheckEmailAddress.bind(this);
            this.onSuccessActivateAccount = this.onSuccessActivateAccount.bind(this);
            this.onSuccessAccountCreationPreValid = this.onSuccessAccountCreationPreValid.bind(this);
            this.onSuccessCreateAccount = this.onSuccessCreateAccount.bind(this);
            this.onSuccessLoginWithPassword = this.onSuccessLoginWithPassword.bind(this);
            this.onSuccessInitOldPassword = this.onSuccessInitOldPassword.bind(this);
            this.onSuccessAccountCreationWithID = this.onSuccessAccountCreationWithID.bind(this);
            this.onSuccessActivateAccountWithID = this.onSuccessActivateAccountWithID.bind(this);
            this.onSuccessInitPassword = this.onSuccessInitPassword.bind(this);
            //this.onFailurePassword = this.onFailurePassword.bind(this);
            //Ajoute les events de l'étape 1
            this.addGlobalEvents();
            this.addEvents();
        }
    }
    addGlobalEvents() {
        // EVENT : click sur le bouton retour
        this.DOM.$back.on("click", (e) => {
            e.preventDefault();
            location.reload();
        });
    }
    addEvents() {
        // Initialise le togglebutton password Dans MainLayout pour activer le toggle sur le password;
        initInputPasswordToggle();
        // Initialiste les toggleButtons oui/non avec callback "on" + "off"
        let toggleButtons = document.querySelectorAll(".js-toggleButton");
        for (let i = 0; i < toggleButtons.length; i++) {
            let element = toggleButtons[i];
            this.toggleButton = new ToggleButton(element, {
                on: function () {
                    const el = document.getElementById("sign-up-no-id");
                    const el2 = document.getElementById("sign-up-id");
                    if (el) {
                        el.style.display = "none";
                    }
                    if (el2) {
                        el2.style.display = "block";
                    }
                },
                off: function () {
                    const el = document.getElementById("sign-up-no-id");
                    const el2 = document.getElementById("sign-up-id");
                    if (el) {
                        el.style.display = "block";
                    }
                    if (el2) {
                        el2.style.display = "none";
                    }
                }
            });
        }
        //Initialise le passwordValidation pour la création de compte
        this.DOM.$wrapper.find('#password-creation').on('change paste keyup select.fndtn.o-accountCreation', (event) => {
            this.activatePasswordControl(event);
        });
        $("#submitCreateAccount").on("click", (e) => {
            $("#form-create-account-id").submit();
        });
        $(".o-identification__changeEmail").on("click", (event) => {
            this.back();
            $(".identification__wrapper").removeClass("-signup");
        });
        $(".js-modify").on("click", (event) => {
            let login = $(event.currentTarget).data("login");
            this.back(login);
        });
        $(".third-party__item").on("click", (event) => {
            let provider = $(event.currentTarget).data("provider");
            let origin = $(event.currentTarget).data('origin');
            // Event
            $(document).foundation('mastertag', 'track_tc_event', {
                obj: this,
                trigger: "clic_type_identification",
                options: {
                    id: "login",
                    category: "connexion",
                    action: origin,
                    label: provider,
                    value: ""
                }
            });
            if (provider === "google") {
                $("#googleform").submit();
            }
            else if (provider === "facebook") {
                $("#facebookform").submit();
            }
            else if (provider === "apple") {
                $("#AppleSignin").submit();
            }
        });
        // On initialise le menu déroulant du tél international
        Foundation.libs.pcc.initPccs();
    }
    back(login) {
        var _this = this;
        //console.log("Back step:" + this.currentStep);
        // SI etape 1 on fait un history back
        if (this.currentStep === STEP1) {
            history.go(-1);
            // Si on est à l'étape 3 on repasse à l'étape2
        }
        else if (this.currentStep === STEP3) {
            $.ajax({
                url: '/Identification/CancelAccountCreation',
                data: { returnUrl: this.returnUrl, login: login },
                success: function (result) {
                    if (result.IsValid) {
                        _this.DOM.$content.html(result.Html);
                        Foundation.libs.common.hidePreloader();
                        //Et on repasse la currentStep à 2
                        _this.currentStep = STEP2;
                        _this.addEvents();
                    }
                },
                error: function () {
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            });
            // Sinon on lance un ajax pour retourner à l'étape 1
        }
        else {
            $.ajax({
                url: '/Identification/BackToStep1',
                data: { toto: this.returnUrl },
                success: function (result) {
                    if (result.IsValid) {
                        _this.DOM.$content.html(result.Html);
                        Foundation.libs.common.hidePreloader();
                        //Et on repasse la currentStep à 1
                        _this.currentStep = STEP1;
                    }
                },
                error: function () {
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            });
        }
    }
    activatePasswordControl(event) {
        var $progress = $('.password__security');
        var rules = 0;
        var $elem = $(event.target).parents('.m-inputWrapper');
        var value = event.target.value;
        var className = "-valid";
        var options = {
            lowerCase: /[a-z]/g,
            upperCase: /[A-Z]/g,
            int: /[0-9]/g,
            spe: /[\W_]/g,
            nb: [8, 32]
        };
        if (value.match(options.lowerCase)) {
            $elem.find('*[data-id="lower"]').addClass(className);
            rules++;
        }
        else {
            $elem.find('*[data-id="lower"]').removeClass(className);
        }
        if (value.match(options.upperCase)) {
            $elem.find('*[data-id="upper"]').addClass(className);
            rules++;
        }
        else {
            $elem.find('*[data-id="upper"]').removeClass(className);
        }
        if (value.match(options.int)) {
            $elem.find('*[data-id="int"]').addClass(className);
            rules++;
        }
        else {
            $elem.find('*[data-id="int"]').removeClass(className);
        }
        if (value.match(options.spe)) {
            $elem.find('*[data-id="special"]').addClass(className);
            rules++;
        }
        else {
            $elem.find('*[data-id="special"]').removeClass(className);
        }
        if (value.length >= options.nb[0] && value.length <= options.nb[1]) {
            $elem.find('*[data-id="nb"]').addClass(className);
            rules++;
        }
        else {
            $elem.find('*[data-id="nb"]').removeClass(className);
        }
        $progress.attr('data-rules', rules);
    }
    onBeginAjax() {
        Foundation.libs.common.showPreloader();
    }
    onFailureAjax() {
        Foundation.libs.common.hidePreloader();
    }
    onSuccessCheckEmailAddress(result) {
        return __awaiter(this, void 0, void 0, function* () {
            // Si Result valide et pas l'html de la modal
            if (result.IsValid && !result.IsModal) {
                this.DOM.$messageContainer.html("");
                this.DOM.$messageContainer.removeClass();
                this.DOM.$messageContainer.addClass(this.DOM.$messageInitClass);
                $("#js-identification__account.identification__account").html(result.Html);
                if (result.IsClient == true) {
                    this.closeAdvantageQuestionPart();
                }
                if (result.IsEmailInBDD == true) {
                    $(".identification__wrapper").addClass("-identification-password");
                }
                $('.identification > h1').text(yield window.Foundation.libs.matyWeglot.adaptStringToLang('Bonjour'));
                //On passe la currentStep à 2
                this.currentStep = STEP2;
                // On initialise les events après la mise à jour HTML
                this.addEvents();
                Foundation.libs.common.hidePreloader();
                // Si Result valide et html de la modal
            }
            else if (result.IsValid && result.IsModal) {
                // on execute la fonction setHtml de la classe ModalIdentification 
                this.DOM.$messageContainer.html("");
                this.DOM.$messageContainer.removeClass();
                this.DOM.$messageContainer.addClass(this.DOM.$messageInitClass);
                this.modal.setHtml(result.Html);
                Foundation.libs.common.hidePreloader();
            }
            else {
                Foundation.libs.common.hidePreloader();
            }
        });
    }
    onSuccessAccountCreationPreValid(result) {
        return __awaiter(this, void 0, void 0, function* () {
            // Si Result valide
            if (result.IsValid) {
                if (result.IsModal) {
                    this.modal.close();
                    this.currentStep = STEP3dot1;
                }
                else {
                    this.currentStep = STEP3;
                }
                $(".identification__wrapper").addClass("-signup");
                $('.identification > h1').text(yield window.Foundation.libs.matyWeglot.adaptStringToLang('Création de votre compte'));
                this.DOM.$content.html(result.Html);
                Foundation.libs.common.hidePreloader();
                // On initialise les events après la mise à jour HTML
                this.addEvents();
            }
        });
    }
    onSuccessGoToCreateAccountWithID(result) {
        this.DOM.$content.html(result.html);
        Foundation.libs.common.hidePreloader();
    }
    onSuccessActivateAccount(result) {
        if (result.IsValid) {
            this.modal.close();
            this.DOM.$content.html(result.Html);
            this.DOM.$messageContainer.html("<p>" + result.Response.Message + "</p>");
            this.DOM.$messageContainer.removeClass();
            this.DOM.$messageContainer.addClass(this.DOM.$messageInitClass);
            this.DOM.$messageContainer.addClass(result.Response.CssClass);
            Foundation.libs.common.hidePreloader();
            this.currentStep = STEP1;
        }
    }
    onSuccessAccountCreationWithID(result) {
        if (result.IsValid) {
            if (result.IsModal) {
                this.modal.setHtml(result.Html);
            }
            else {
                this.DOM.$content.html(result.Html);
                this.addEvents();
            }
            Foundation.libs.common.hidePreloader();
        }
    }
    onSuccessActivateAccountWithID(result) {
        if (result.IsValid) {
            this.modal.close();
            this.DOM.$content.html(result.Html);
            this.DOM.$messageContainer.html("<p>" + result.Response.Message + "</p>");
            this.DOM.$messageContainer.removeClass();
            this.DOM.$messageContainer.addClass(this.DOM.$messageInitClass);
            this.DOM.$messageContainer.addClass(result.Response.CssClass);
            Foundation.libs.common.hidePreloader();
            this.currentStep = STEP1;
        }
    }
    onSuccessCreateAccount(result) {
        Foundation.libs.common.hidePreloader();
        if (result.IsValid === false) {
            $.each(result.Errors, function (a, b) {
                var $summaryUl = $("[data-validation-message=" + a + "]");
                $summaryUl.empty();
                $summaryUl.append(b);
                $summaryUl.parents("div:first").addClass('-error');
            });
        }
        else {
            $(document).foundation('mastertag', 'track_tc_event', {
                obj: this,
                trigger: 'subscription',
                options: {
                    id: "subscription",
                    category: "subscription",
                    action: "maty",
                    label: "",
                    value: ""
                }
            });
        }
    }
    onSuccessLoginWithPassword(result) {
        Foundation.libs.common.hidePreloader();
        if (result.IsValid) {
            if (result.HasError === undefined || result.HasError == null) {
                window.location = result.UrlReturn;
            }
            else {
                this.DOM.$content.html(result.Html);
                this.closeAdvantageQuestionPart();
                this.addEvents();
            }
        }
    }
    onSuccessInitPassword(result) {
        console.log("AAAAh");
        console.log(result);
        Foundation.libs.common.hidePreloader();
        if (result.IsValid) {
            this.DOM.$wrapper.replaceWith(result.Html);
            $("#js-identification__account.identification__account").html(result.HtmlConnect);
            this.closeAdvantageQuestionPart();
            if (result.JsInnerRedirect) {
                this.DOM.$title.text("Identification");
            }
            this.addEvents();
        }
    }
    onSuccessInitOldPassword(result) {
        Foundation.libs.common.hidePreloader();
        if (result.IsValid) {
            if (result.HasError == undefined || result.HasError == null || result.HasError == false) {
                window.location = result.UrlReturn;
            }
            else {
                this.DOM.$content.html(result.Html);
                this.closeAdvantageQuestionPart();
                this.addEvents();
            }
        }
    }
    closeAdvantageQuestionPart() {
        $(".identification__faq").remove();
    }
}
//# sourceMappingURL=maty.identification.js.map